// extracted by mini-css-extract-plugin
export default {"root":"NavItemList_root__aNkQD","childMenu":"NavItemList_childMenu__N5q8B"};